var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoDemotive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-544.000000, -735.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(329.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.000000, 471.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M16,0 C7.16344416,0 0,7.16344416 0,16 C0,24.8365565 7.16344416,32 16,32 C24.8365565,32 32,24.8365565 32,16 C32,7.16344416 24.8365565,0 16,0 Z M16.0000003,29.8666673 C8.34165165,29.8666673 2.13333338,23.658349 2.13333338,16.0000003 C2.13333338,8.34165165 8.34165165,2.13333338 16.0000003,2.13333338 C23.658349,2.13333338 29.8666673,8.34165165 29.8666673,16.0000003 C29.8666673,19.6776691 28.4057191,23.2047101 25.8052146,25.8052146 C23.2047101,28.4057191 19.6776691,29.8666673 16.0000003,29.8666673 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "icon",
    cx: 11.2000002,
    cy: 12.2666669,
    r: 1.60000003
  }), /*#__PURE__*/React.createElement("circle", {
    className: "icon",
    cx: 20.8000005,
    cy: 12.2666669,
    r: 1.60000003
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M20.2666671,21.3333338 L11.7333336,21.3333338 C11.1442298,21.3333338 10.6666669,21.8108967 10.6666669,22.4000005 C10.6666669,22.9891042 11.1442298,23.4666672 11.7333336,23.4666672 L20.2666671,23.4666672 C20.8557709,23.4666672 21.3333338,22.9891042 21.3333338,22.4000005 C21.3333338,21.8108967 20.8557709,21.3333338 20.2666671,21.3333338 Z",
    id: "Path"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDemotive);
export default __webpack_public_path__ + "static/media/picto-demotive.5665d52090324cf45762e75677faffcc.svg";
export { ForwardRef as ReactComponent };